import { Collapse, LinearProgress } from '@ethings/ui-toolkit';
import { styled } from '@mui/material/styles';
import { FC } from 'react';

const StyledCollapse = styled(Collapse)({
  position: 'absolute',
  width: '100%',
  zIndex: 401,
});

export const LoadingComponent: FC<{ isLoading: boolean }> = ({ isLoading }) => (
  <StyledCollapse in={isLoading}>
    <LinearProgress color="inherit" />
  </StyledCollapse>
);
